module.exports = __webpack_public_path__ + "static/merge-f189704ad28dc81793822ad0d1b2262c.png";